import React from "react";
import { Container } from "react-bootstrap";
import { ArticleSection, StyledButton, PageHeaderSection, HistorySection, DividerSection } from "../components";
import { useScrollToTopAndNavigate, useWindowSize } from "../hooks";
import { useTranslation } from "react-i18next";

import bg_01 from "./../images/Content/Backhaus-Häussler-57.jpg"
import bg_02 from "./../images/Content/Backhaus-Häussler-49.jpg"
import bg_03 from "./../images/Content/Backhaus-Häussler-34.jpg"
import bg_05 from "./../images/Content/haeussler-job-01.webp"

const About: React.FunctionComponent = () => {
  const handleNavigation = useScrollToTopAndNavigate();
  const { width } = useWindowSize();
  const { t } = useTranslation(["about", "common"]);

  const contentStyle: React.CSSProperties = {
    fontFamily: "Avenir Next Codensed Regular",
    fontWeight: 300,
    fontSize: "28px",
    lineHeight: "45px",
    color: "#342714",
    letterSpacing: ".05em"
  };


  return (
    <Container>
      <PageHeaderSection
        id={"section_start"}
        headline={t("page_header.headline")}
        subheadline={t("page_header.subheadline")}
        content={<></>}
      />
      <ArticleSection
        layout="article_left"
        title={t("sections.challenge.title")}
        content={
          <div style={contentStyle}>{t("sections.challenge.content")}</div>
        }
        imageUrl={bg_05}
        backgroundColor="#DDEBEA"
      />
      <ArticleSection
        layout="article_right_bg"
        title={t("sections.why_glutenfree.title")}
        content={
          <div style={contentStyle}>{t("sections.why_glutenfree.content")}</div>
        }
        imageUrl={bg_03}
        backgroundColor="#F4EBE5"
      />
      <DividerSection
        imageUrl={bg_01}
        height="55vh"
      />
      <div>
        <HistorySection
          header={t("sections.historychallenge.wish.header")}
          subHeader={t("sections.history.wish.subHeader")}
          content={t("sections.history.wish.content")}
          imageUrl={bg_01}
          imageSize={{ width: "100%", height: "auto", objectFit: "cover" }}
          imageDescription={t("sections.history.wish.imageDescription")}
          direction="left"
          afterAlign="left"
          windowWidth={width}
        />
        <HistorySection
          header={t("sections.history.opportunity.header")}
          subHeader={t("sections.history.opportunity.subHeader")}
          content={t("sections.history.opportunity.content")}
          imageUrl={bg_02}
          imageSize={{ width: "100%", height: "auto", objectFit: "cover" }}
          imageDescription={t("sections.history.opportunity.imageDescription")}
          direction="right"
          afterAlign="right"
          windowWidth={width}
        />
        <HistorySection
          header={t("sections.history.goal.header")}
          subHeader={t("sections.history.goal.subHeader")}
          content={t("sections.history.goal.content")}
          imageUrl={bg_01}
          imageSize={{ width: "100%", height: "auto", objectFit: "cover" }}
          imageDescription={t("sections.history.goal.imageDescription")}
          direction="left"
          afterAlign="none"
          windowWidth={width}
        />
      </div>
      <ArticleSection
        layout="article_right_bg"
        title={t("sections.philosophy.title")}
        content={
          <div style={contentStyle}>{t("sections.philosophy.content")}</div>
        }
        imageUrl={bg_03}
        backgroundColor="#DDEBEA"
      />
      <PageHeaderSection
        id={"section_end"}
        headline={t("sections.closing.headline")}
        subheadline={t("sections.closing.subheadline")}
        style={{ marginBottom: 100, marginTop: 100 }}
        content={
          <div style={{ justifyContent: "center", display: "flex" }}>
            <StyledButton title={t("sections.closing.button")} onClick={() => handleNavigation("/shop")} />
          </div>
        }
      />
      <ArticleSection
        layout="article_left"
        title={t("common:sections.jobs.title")}
        content={
          <div>
            <p style={contentStyle}>{t("common:sections.jobs.content")}</p>
            <StyledButton title={t("common:sections.jobs.button")} onClick={() => { handleNavigation("https://bhmm.de/employees#job-offers", { openInNewTab: true }) }} />
          </div>
        }
        imageUrl={bg_05}
        backgroundColor="#DDEBEA"
      />
    </Container>
  );
}

export default About;
